<template>
  <div class="content">
    <h2 class="title is-4">{{ $t('instruction_view.choose_one_item') }}</h2>
    <div class="buttons are-medium buttons-content-layout">
      <b-button
        v-for="(item, index) in selectionItems"
        :key="index"
        type="is-light"
        @click="selectItem(item)"
        :disabled="item.disabled"
      >
        <div class="btn-center-content">
          <b-icon :icon="item.icon"></b-icon>
          {{ $t(item.label) }}
        </div>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'selection',
  data() {
    return {
      selectionItems: [
        {
          type: 'action',
          label: 'instruction_view.action_option',
          icon: 'check',
        },
        {
          type: 'yesno',
          label: 'instruction_view.yes_no_option',
          icon: 'help',
        },
        {
          type: 'multiplechoice',
          label: 'instruction_view.multiple_choice_option',
          icon: 'menu',
        },
        {
          type: 'singlechoice',
          label: 'instruction_view.single_choice_option',
          icon: 'radiobox-marked',
        },
        {
          type: 'textnumber',
          label: 'instruction_view.text_number_option',
          icon: 'pencil',
        },
        {
          type: 'tablequestion',
          label: 'instruction_view.table_option',
          icon: 'table',
        },
        {
          type: 'smarttablequestion',
          label: 'instruction_view.smart_table_option',
          icon: 'form-dropdown',
        },
        {
          type: 'importcsv',
          label: 'instruction_view.import_csv_option',
          icon: 'file',
        },
      ],
    };
  },
  methods: {
    selectItem(item) {
      if (item.disabled) {
        return;
      }
      this.$emit('itemSelected', item);
    },
  },
};
</script>

<style scoped>
.disabled {
}

.buttons-content-layout {
  gap: 10px;
  display: grid;
  grid-template-columns: auto auto;
}

.btn-center-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 150px;
}
</style>
./selection.vue
